<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">
    <sidebar></sidebar>
    <div class="card-panel-main col-lg-9 mb-5" style="position: absolute; right: 28vw; width: 51vw; height: auto;">
      <div class="card card-body card-panel-box border-0 p-5" style="margin: 1vw .9vw;">
        <div class="d-flex justify-content-between">
          <h3>
            5M /  جدول ارزيابی موارد قوت ها و فرصت ها   / {{ name_route }}
          </h3>
          <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>

        </div>        <hr class="mb-3">
        <form v-if="items.length" style="transform: translateX(2vw)"   class="">
          <table class="table " style="width: 20vw !important;" >
            <thead>
            <tr>
              <th rowspan="2">ردیف</th>
              <th rowspan="2">شاخص</th>
              <th rowspan="2">معیارها</th>
              <th rowspan="2">ضریب اهمیت</th>
              <th rowspan="2">نسبت وزنی</th>
              <th colspan="2">تبيين فرصت ها و تهديدات</th>
              <th colspan="2">ميزان جذابيت (تهديد يا فرصت)</th>
              <th colspan="2">نحوه پاسخگويي در وضع موجود</th>
              <th colspan="2">نحوه پاسخگويي در وضع آتي</th>
            </tr>
            <tr>
              <th>فرصتها</th>
              <th>تهدیدات</th>
              <th>نمره</th>
              <th>امتیاز</th>
              <th>نمره</th>
              <th>امتیاز</th>
              <th>نمره</th>
              <th>امتیاز</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in items" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>
                <div v-if="item.criteria_pestel.length" class="row">
                  <span v-for="subItem in item.criteria_pestel" :key="subItem.id">{{ subItem.name }}</span>
                </div>
                <div v-else>--</div>
              </td>
              <td><input type="text" v-model="item.importance_factor" class="form-control"></td>
              <td><input type="text" v-model="item.weight_ratio" class="form-control"></td>
              <td><textarea v-model="item.opportunities" class="form-control" cols="30" rows="10"></textarea></td>
              <td><textarea v-model="item.threats" class="form-control" cols="30" rows="10"></textarea></td>
              <td><input type="text" v-model="item.score_attractiveness" class="form-control"></td>
              <td><input type="text" v-model="item.points_attractiveness" class="form-control"></td>
              <td><input type="text" v-model="item.score_responsiveness_now" class="form-control"></td>
              <td><input type="text" v-model="item.points_responsiveness_now" class="form-control"></td>
              <td><input type="text" v-model="item.score_responsiveness_next" class="form-control"></td>
              <td><input type="text" v-model="item.points_responsiveness_next" class="form-control"></td>
            </tr>
            </tbody>
          </table>
        </form>
        <hr  v-if="items.length" class="mt-2 mb-2">
<center>
  <button v-if="items.length" @click.prevent="submitForm" type="submit" class="btn btn-primary btn-submit-1">ذخیره</button>
</center>
        <center v-if="!items.length">
          موردی یافت نشد
        </center>
        <hr class="mb-3 mt-3">
        <div class="d-flex justify-content-between">
          <p @click.prevent="back" class="btn btn-submit-1 btn-primary">مرحله قبلی</p>
          <p @click.prevent="next" class="btn btn-submit-1 btn-primary">مرحله بعدی</p>
        </div>
      </div>
      </div>
  </div>
</template>

<script>
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";
import {useToast} from "vue-toastification";
const toast = useToast();

export default {
  name: 'HomeView',
  components: {
    Sidebar,
    splash
  },
  data() {
    return {
      items: [],
      counter: 1,
      name_route: '',

    }
  },
  methods: {
    next() {
      if (this.counter===5)return false;
      this.counter++
      this.getName()



    },
    back() {
      if (this.counter===1)return false;
      this.counter--
      this.getName()

    },
    checkIsMother() {
      if (this.is_mother) {
        router.push('/mother_items')
        return
      }
    },
    all() {
      fetch(`${this.base_url}/PestelVariables/all_table`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          'type': this.counter,
        }),
      })
          .then(response => response.json())
          .then((response) => {
            if (response.all) {
              this.items.length = 0
              this.items = [...response.all]
            }
          }).catch((err) => {
      })
    },
    submitForm() {
      fetch(`${this.base_url}/PestelVariables/store_table`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify(this.items),
      })
          .then(response => response.json())
          .then((response) => {
            if (response.message) {
              toast.success(response.message)
              this.all()
            }
          }).catch((err) => {

      })
    },
    getName() {
      if (this.counter === 1) {
        this.name_route = 'نیرو انسانی (man)'
      } else if (this.counter === 2) {
        this.name_route = 'تجهیزات ( Machine )'
      } else if (this.counter === 3) {
        this.name_route = 'مواد و ملزومات (material )'
      } else if (this.counter === 4) {
        this.name_route = 'روش ها و رویه ها ( mechanism  )'
      } else if (this.counter === 5) {
        this.name_route = 'مدیریت (management )'
      }
      this.all()

    },
  },
  mounted() {
    this.checkIsMother()
    this.getName()
  }
}
</script>

<style scoped lang="scss">
a {
  font-size: 1vw;
}

h3 {
  font-size: 1.3vw !important;
}

small, span {
  font-size: 1vw !important;
}
input{
  width: 4.2vw;
  text-align: center;
}
textarea{
  width: 6vw;
}
</style>
